function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-wrapper">
        {/* MAIN FOOTER CONTENT */}
        <div className="footer-main">
          {/* About Section */}
          <div className="footer-section">
            <h3 className="footer-section-title">About Us</h3>
            <p className="footer-section-text">
              Kriva Bharat Private Limited is a platform dedicated to connecting service providers with customers across India. We believe in making quality services accessible to everyone through digital connectivity.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-section-title">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="/" className="footer-link">Home</a></li>
              <li><a href="/services" className="footer-link">Services</a></li>
              <li><a href="/about-us" className="footer-link">About Us</a></li>
              <li><a href="/contact" className="footer-link">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-section-title">Services</h3>
            <ul className="footer-links">
              <li><a href="/services" className="footer-link">Find Services</a></li>
              <li><a href="/services" className="footer-link">Browse Partners</a></li>
              <li><a href="/services" className="footer-link">Book Appointments</a></li>
              <li><a href="/contact" className="footer-link">Get Support</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-section-title">Contact Us</h3>
            <div className="footer-contact">
              <p><span className="footer-label">Email:</span> <a href="mailto:support@krivabharat.com" className="footer-link">support@krivabharat.com</a></p>
              <p><span className="footer-label">Website:</span> <a href="http://krivabharat.com/" className="footer-link" target="_blank" rel="noopener noreferrer">krivabharat.com</a></p>
            </div>
          </div>
        </div>

        {/* FOOTER BOTTOM */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} Kriva Bharat Private Limited. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <a href="#" className="footer-link-small">Privacy Policy</a>
              <span className="divider">•</span>
              <a href="#" className="footer-link-small">Terms of Service</a>
              <span className="divider">•</span>
              <a href="#" className="footer-link-small">Cookies Policy</a>
            </div>
          </div>
          <p className="footer-tagline">
            Sign up at <a href="https://krivabharat.com" className="footer-link" target="_blank" rel="noopener noreferrer">krivabharat.com</a> — Connect, Book, Serve. All in one place!
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
